'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider-hoc');
const Carousel = require('../../../components/carousel');
const CouponsGrid = require('../../coupons/views/coupons-grid-hoc');
const CouponsCategoryTabs = require('../../coupons/views/coupons-category-tabs');
const CtaTopOffers = require('../../coupons/views/cta-top-offers');
const FavoriteMerchants = require('../../merchant/views/favorite-merchants');
const RichText = require('../../shared/views/rich-text');
const LeaderboardCallout = require('../../shared/views/leaderboard-callout');
const LinkList = require('../../../components/link_list');
const Footer = require('../../../components/footer');
const { pruneData } = require('../../support/prune-data');

const minCouponsForCarousel = 4;

function Home({ payload, deps }) {
  const {
    keyAuthData,
    categoryData,
    navigationMerchants,
    advertsForCarousel,
    couponsForGrid,
    couponsForTabs,
    homeMerchants,
    favoriteMerchants,
    leaderboardAdverts,
  } = payload;
  const {
    routes,
    showFavoriteMerchants,
    isTouch,
    csrfToken,
    showSeoContent,
    showLeaderboardCallout,
    showTopOffers,
  } = deps;

  return h('article.wrapper-page', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'home',
      merchants: navigationMerchants,
    }),
    h('.page-container', [
      advertsForCarousel &&
        advertsForCarousel.length >= minCouponsForCarousel &&
        h(
          '.row',
          h(
            '.twelve.columns',
            Carousel({
              routes: pruneData(
                routes,
                'merchant:show',
                'redemption:terms',
                'redemption:main'
              ),
              items: advertsForCarousel,
              isTouch,
              className: 'carousel',
              containsOffers: true,
            })
          )
        ),
      LeaderboardCallout({
        display: showLeaderboardCallout,
        adverts: leaderboardAdverts,
        isTouch,
        routes: pruneData(routes, 'merchant:show'),
      }),
      showFavoriteMerchants &&
        h(
          '.row',
          h(
            '.twelve.columns',
            FavoriteMerchants({
              merchants: favoriteMerchants,
              routes: pruneData(routes, 'merchant:show'),
              show: showFavoriteMerchants,
            })
          )
        ),
    ]),
    h(CouponsGrid, {
      coupons: couponsForGrid,
      routes,
      isTouch,
      leaderboardAdverts,
      showSeoContent,
      csrfToken,
    }),
    h('.page-container', [
      h(
        '.row',
        h(
          '.twelve.columns',
          h(CouponsCategoryTabs, {
            keyAuthData,
            categoryData,
            coupons: couponsForTabs,
            routes,
          })
        )
      ),
      CtaTopOffers({ routes, show: showTopOffers }),
      RichText({
        display: showSeoContent,
        sectionHeadingKey: 'modules.home.SecondarySeoHeading',
        richTextKey: 'modules.home.SecondarySeoText',
      }),
    ]),
    LinkList({ links: homeMerchants, routes }),
    h('.page-container', [h('.row', h('.twelve.columns', Footer()))]),
  ]);
}

module.exports = Home;
